import {
  faBlogger,
  faFacebook,
  faHive,
  faSoundcloud,
  faSpotify,
  faXTwitter,
  faVimeo,
  faWordpress,
  faYoutube,
  faUnsplash,
} from '@fortawesome/free-brands-svg-icons';
import {
  faPlug,
  faSearch,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from 'components/Image';
import FeedlyLogo from 'images/brands/feedly.svg';
import GMapsLogo from 'images/brands/gmaps.svg';
import GoogleSearchConsoleLogo from 'images/brands/google-search-console.svg';
import InstagramLogo from 'images/brands/instagram.png';
import SteemLogo from 'images/steem-logo.svg';
import SteemLogoLight from 'images/steem.svg';
import ThreeSpeakLogo from 'images/3speak.svg';
import AdsenseLogo from 'images/brands/adsense.png';
import GoogleAnalyticsLogo from 'images/brands/google-analytics.png';
import MatomoLogo from 'images/brands/matomo.png';
import PlausibleLogo from 'images/brands/plausible.svg';
import SimpleAnalyticsLogo from 'images/brands/simple-analytics.svg';
import { makeStyles } from 'tss-react/mui';
import shadow from 'helpers/shadow';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import Link from 'next/link';
import UserContext from '../General/UserContext';
import React, { useContext } from 'react';

const useStyles = makeStyles()(() => ({
  card: {
    borderRadius: 16,
    width: 150,
    height: 110,
    boxShadow: shadow.md,
  },
}));

export default function IntegrationsGrid({ articles }) {
  const { classes } = useStyles();

  const { theme } = useContext(UserContext);

  const useDarkMode = theme === 'dark';

  const icons = {
    hive: (
      <FontAwesomeIcon
        style={{ width: 55, height: 55 }}
        icon={faHive}
        color="#D51234"
      />
    ),
    youtube: (
      <>
        <FontAwesomeIcon
          style={{ width: 55, height: 55 }}
          icon={faYoutube}
          color="#E73223"
        />
      </>
    ),
    seo: (
      <>
        <FontAwesomeIcon style={{ width: 55, height: 55 }} icon={faSearch} />
      </>
    ),
    'google-search-console': (
      <>
        <Image
          priority
          unoptimized
          src={GoogleSearchConsoleLogo}
          alt="Google Search Console"
          height={55}
          width={55}
        />
      </>
    ),
    'google-maps': (
      <>
        <Image
          priority
          unoptimized
          src={GMapsLogo}
          alt="Google Maps"
          height={55}
          width={55}
        />
      </>
    ),
    vimeo: (
      <>
        <FontAwesomeIcon
          style={{ width: 55, height: 55 }}
          icon={faVimeo}
          color="#44BBFF"
        />
      </>
    ),
    '3speak': (
      <>
        <Image
          priority
          src={ThreeSpeakLogo}
          alt="3speak"
          height={55}
          width={55}
          unoptimized
        />
      </>
    ),
    facebook: (
      <>
        <FontAwesomeIcon
          style={{ width: 55, height: 55 }}
          icon={faFacebook}
          color="#1778F3"
        />
      </>
    ),
    twitter: (
      <>
        <FontAwesomeIcon style={{ width: 55, height: 55 }} icon={faXTwitter} />
      </>
    ),
    instagram: (
      <>
        <Image
          priority
          unoptimized
          src={InstagramLogo}
          alt="Instagram"
          height={55}
          width={55}
        />
      </>
    ),
    'google-adsense': (
      <>
        <Image
          priority
          unoptimized
          src={AdsenseLogo}
          alt="Adsense"
          height={55}
          width={55}
        />
      </>
    ),
    'google-analytics': (
      <>
        <Image
          priority
          unoptimized
          src={GoogleAnalyticsLogo}
          alt="Google Analytics"
          height={55}
          width={55}
        />
      </>
    ),
    matomo: (
      <>
        <Image
          priority
          unoptimized
          src={MatomoLogo}
          alt="Matomo"
          height={55}
          width={75}
        />
      </>
    ),
    plausible: (
      <>
        <Image
          priority
          unoptimized
          src={PlausibleLogo}
          alt="Plausible"
          height={55}
          width={55}
        />
      </>
    ),
    'simple-analytics': (
      <>
        <Image
          priority
          unoptimized
          src={SimpleAnalyticsLogo}
          alt="Simple Analytics"
          height={55}
          width={55}
        />
      </>
    ),
    'unsplash-block': (
      <>
        <FontAwesomeIcon style={{ width: 55, height: 55 }} icon={faUnsplash} />
      </>
    ),
    feedly: (
      <>
        <Image
          priority
          src={FeedlyLogo}
          alt="Feedly"
          height={55}
          width={55}
          unoptimized
        />
      </>
    ),
    api: (
      <>
        <FontAwesomeIcon style={{ width: 55, height: 55 }} icon={faPlug} />
      </>
    ),
    'migrating-from-wordpress': (
      <>
        <FontAwesomeIcon
          style={{ width: 55, height: 55 }}
          icon={faWordpress}
          color="#22759B"
        />
      </>
    ),
    'migrating-from-blogger': (
      <>
        <FontAwesomeIcon
          style={{ width: 55, height: 55 }}
          icon={faBlogger}
          color="#E86733"
        />
      </>
    ),
    soundcloud: (
      <>
        <FontAwesomeIcon
          style={{ width: 55, height: 55 }}
          icon={faSoundcloud}
          color="#F7620D"
        />
      </>
    ),
    spotify: (
      <>
        <FontAwesomeIcon
          style={{ width: 55, height: 55 }}
          icon={faSpotify}
          color="#21D755"
        />
      </>
    ),
    steem: (
      <>
        <Image
          priority
          src={useDarkMode ? SteemLogoLight : SteemLogo}
          alt="Steem"
          height={55}
          width={55}
          unoptimized
        />
      </>
    ),
    request: (
      <FontAwesomeIcon style={{ width: 60, height: 60 }} icon={faEnvelope} />
    ),
  };

  return (
    <div className="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 md:tw-grid-cols-4 xl:tw-grid-cols-5 tw-gap-4">
      {[...articles, { title: 'Request', slug: 'request' }].map(integration => {
        return (
          <Link
            href={
              integration.slug === 'request'
                ? '/about/contact?integration=true'
                : `/help/article/${integration.slug}`
            }
            key={integration.slug}
          >
            <Card className={classes.card}>
              <CardActionArea className="h-100 w-100">
                <div
                  className="w-100 text-center"
                  style={{ position: 'absolute', bottom: 5, left: 0 }}
                >
                  <Typography variant="overline">
                    {integration.shorttitle || integration.title}
                  </Typography>
                </div>
                <div className="container h-100">
                  <div className="row h-100">
                    <div className="col my-auto text-center">
                      <div className="w-100 pb-4">
                        {icons[integration.slug]}
                      </div>
                    </div>
                  </div>
                </div>
              </CardActionArea>
            </Card>
          </Link>
        );
      })}
    </div>
  );
}
